export default __webpack_public_path__ + "static/media/green-candy.15ea5487.png";